/**
 * Zile lucratoare, varianta de client — doar pentru navigarea din `Alt+←/→`.
 *
 * Autoritatea ramane `banking_calendar`, populat, nu calculat: Pastele ortodox si Rusaliile sunt
 * mobile, iar Guvernul adauga punți prin hotarare, deci niciun algoritm nu e complet. Cand
 * calendarul e deja incarcat (`useReferinta`), se foloseste EL; cand nu e — primul cadru dupa
 * deschiderea aplicatiei — se cade pe sarirea weekendului, care e o aproximare acceptabila pentru
 * o sageata de navigare si pentru NIMIC altceva.
 *
 * O amanare NU foloseste functia asta: ea trece prin server, care refuza daca intervalul nu e
 * acoperit. Diferenta e intentionata — a naviga pe o zi nelucratoare nu strica nimic, a PLANIFICA
 * o plata pe ea da.
 */

import { addDays } from '@evomag/core/format';

/** Forma minima a unui rand de calendar; se potriveste cu `ZiCalendar` din `useReferinta`. */
export interface ZiLucratoareCunoscuta {
  calDate: string;
  isBusinessDay: boolean;
}

function esteWeekend(iso: string): boolean {
  const zi = new Date(`${iso}T12:00:00Z`).getUTCDay();
  return zi === 0 || zi === 6;
}

/**
 * Urmatoarea zi lucratoare in directia data (`1` inainte, `-1` inapoi).
 *
 * `calendar` e optional. Cand vine, decide el; zilele din afara intervalului lui cad tot pe regula
 * de weekend, ca navigarea sa nu se opreasca la marginea ferestrei incarcate.
 */
export function ziLucratoare(
  iso: string,
  directie: 1 | -1,
  calendar?: readonly ZiLucratoareCunoscuta[],
): string {
  const stiute =
    calendar === undefined
      ? null
      : new Map(calendar.map((z) => [z.calDate, z.isBusinessDay] as const));

  const nelucratoare = (zi: string): boolean => {
    const cunoscuta = stiute?.get(zi);
    return cunoscuta === undefined ? esteWeekend(zi) : !cunoscuta;
  };

  let candidat = addDays(iso, directie);
  // Maximum 10 pasi: acopera si o punte lunga (1-2 si 6-7 ianuarie cu weekend intre) fara sa poata
  // bucla la infinit daca cineva marcheaza din greseala o luna intreaga ca nelucratoare.
  for (let i = 0; i < 10 && nelucratoare(candidat); i += 1) {
    candidat = addDays(candidat, directie);
  }
  return candidat;
}

/** Aceeasi zi a saptamanii, cu o saptamana inainte/inapoi. */
export function saptamana(iso: string, directie: 1 | -1): string {
  return addDays(iso, 7 * directie);
}
